const {required} = require("@common/react/cs-form/validators/required");

exports.gaugeFormConfig = {
    fields: {
        title: {
            transforms: ["trim"],
            validators: [required],
            debounce: true,
        },
    },
};
